"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const sshSchema = Yup.object()
  .shape({
    config: Yup.string().required(),
    command: Yup.string().required(),
    host: Yup.string().required(),
    port: Yup.string(),
    username: Yup.string().required(),
    isProxyNode: Yup.boolean().required(),
    proxy: Yup.string().when("isProxyNode", {
      is: true,
      then: Yup.string().required(),
      otherwise: Yup.string()
    })
  })
  .required();
class SSHNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    return helper_1.isValid(
      [
        { schema: sshSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.SSHNodeValidation = SSHNodeValidation;
//# sourceMappingURL=SSHNodeValidation.js.map
